import type { MasonryLayoutDefaults } from './defaultSettings';

export const mapMasonryLayoutSettings = (settings: MasonryLayoutDefaults) => {
  const {
    masonryColumnsMode,
    masonryColumnsDesktopLarge,
    masonryColumnsDesktopMedium,
    masonryColumnsDesktopSmall,
    masonryColumnsTablet,
    masonryColumnsMobile,
    masonryItemSpacing,
    masonryShowLoadMoreButton,
    showLoadMoreButton,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    masonryItemsPerPage,
    masonryItemsPerPageOnMobile
  } = settings;

  return {
    columnsMode: masonryColumnsMode,
    columnsDesktopLarge: masonryColumnsDesktopLarge,
    columnsDesktopMedium: masonryColumnsDesktopMedium,
    columnsDesktopSmall: masonryColumnsDesktopSmall,
    columnsTablet: masonryColumnsTablet,
    columnsMobile: masonryColumnsMobile,
    itemSpacing: masonryItemSpacing,
    // Приоритет: новая настройка ?? старая настройка
    showLoadMoreButton: showLoadMoreButton ?? masonryShowLoadMoreButton,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    itemsPerPage: masonryItemsPerPage,
    itemsPerPageOnMobile: masonryItemsPerPageOnMobile
  };
};
